import { Link } from 'react-router-dom';
import type { CaseItem } from '@/types/content';
import ResponseCard from '@/components/base/ResponseCard';
import SectionHeading from '@/components/base/SectionHeading';

interface ResponsesPreviewProps {
  items: readonly CaseItem[];
}

export default function ResponsesPreview({ items }: ResponsesPreviewProps) {
  const flat = items
    .flatMap((item) => item.responses.map((res) => ({ res, caseTitle: item.title, caseId: item.id })))
    .slice(0, 4);

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        eyebrow="当事人回应"
        title="他们是怎么说的"
        desc="所有回应均标注立场与来源，区分“已澄清”与“尚未回应”，不做主观替答。"
        action={
          <Link
            to="/responses"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md border border-foreground-300 text-foreground-800 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            全部回应合集
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {flat.map(({ res, caseTitle }, index) => (
          <ResponseCard key={`${res.personId}-${index}`} item={res} caseTitle={caseTitle} />
        ))}
      </div>
      </div>
    </section>
  );
}